import { useState } from "react";
import { EmployeeOverviewListItem } from "../models/employeeOverview.model";

export function useEmployeeOverviewActions() {
    const [selectedEmployee, setSelectedEmployee] = useState<EmployeeOverviewListItem | null>(null);

    const handleSelectEmployee = (employee: EmployeeOverviewListItem) => {
        setSelectedEmployee(employee);
    };

    const handleClosePreview = () => {
        setSelectedEmployee(null);
    };

    return {
        selectedEmployee,
        /**
         * Derived from `selectedEmployee`, named to match CVList's `selectedPersonId` precedent
         * (FS §3) for anything that only needs the id (e.g. the grid's responsive column count).
         * `null` here means either "nothing selected" or "an employee with no CV is selected" —
         * callers that must tell those two cases apart (deciding which panel to render) need
         * `selectedEmployee` instead.
         */
        selectedPersonId: selectedEmployee?.personId ?? null,
        handleSelectEmployee,
        handleClosePreview,
    };
}
